import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, canonical, type = 'website', image }) => {
  const base = 'SFOALC';
  const fullTitle = title ? `${title} - ${base}` : 'SFOALC - Société Française des Ophtalmologistes Adaptateurs de Lentilles de Contact';
  const desc = description || "La SFOALC regroupe les ophtalmologistes spécialistes de la contactologie médicale. Formation continue, annuaire, publications scientifiques.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="SFOALC" />
      {canonical && <link rel="canonical" href={canonical} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="robots" content="index, follow" />
      <meta name="theme-color" content="#1e3a5f" />
    </Helmet>
  );
};

export default SEO;
